import { render } from "./EditArticleView.vue?vue&type=template&id=7ad452e6&scoped=true&ts=true"
import script from "./EditArticleView.vue?vue&type=script&lang=ts"
export * from "./EditArticleView.vue?vue&type=script&lang=ts"

import "./EditArticleView.vue?vue&type=style&index=0&id=7ad452e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad452e6"]])

export default __exports__